module.exports = __webpack_public_path__ + "static/media/OP_IPSA_PoweredBy_Logo.bbffa34f.svg";